import { Flame } from "lucide-react";
import { useState } from "react";
import { useT } from "../lib/i18n";
import { useSelectedDate } from "../lib/selectedDate";

type Props = {
  weekNumber: number;
  targetKcal: number;
  milestone: boolean;
  onOpen: () => void;
};

export function RefeedBanner({ weekNumber, targetKcal, milestone, onOpen }: Props) {
  const t = useT();
  const { selectedDate } = useSelectedDate();
  const key = `lean.dismissed_refeed_${selectedDate}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === "1");
  if (dismissed) return null;
  const titleKey = milestone ? "today.refeed.milestone_title" : "today.refeed.title";
  return (
    <div
      className={`relative rounded-2xl border ${
        milestone
          ? "bg-fuchsia-500/15 border-fuchsia-500/40"
          : "bg-orange-500/10 border-orange-500/30"
      }`}
    >
      <button onClick={onOpen} className="w-full text-left p-4 pr-10 flex items-start gap-3">
        <Flame aria-hidden="true" size={22} className="text-amber-400 shrink-0" />
        <div className="flex-1">
          <div className="text-sm font-medium">{t(titleKey, { n: weekNumber })}</div>
          <div className="text-sm text-fg-muted mt-0.5">
            {t("today.refeed.body", { kcal: targetKcal })}
          </div>
        </div>
      </button>
      <button
        type="button"
        aria-label={t("common.close")}
        onClick={() => { localStorage.setItem(key, "1"); setDismissed(true); }}
        className="absolute top-3 right-3 text-fg-faint px-1"
      >✕</button>
    </div>
  );
}
